export const DEBOUNCE_DURATION = 850

export const MAP_BLOCK_PADDING = 80
export const MAP_INLINE_PADDING = 100

export const NO_DATA_AVAILABLE_MESSAGE = "No data available"

export const ZoneType = {
  SCHOOL: "School",
  CAMPUS: "Campus",
  BUILDING: "Building",
  FLOOR: "Floor",
  INDIVIDUAL: "Individual",
  DEFAULT: "Default",
}
